import axios from "axios";
import { base_url } from "../../utils/baseUrl";
import { config } from "../../utils/axiosconfig";

const getPhotographs = async () => {
  const UserString = localStorage.getItem("user");
  const User = JSON.parse(UserString);
  const id = User.id;
  const response = await axios.get(`${base_url}ppp/${id}/getImage`);
 
  return response.data;
   
};
const createPhotographs = async (formData) => {
  const UserString = localStorage.getItem("user");
  const User = JSON.parse(UserString);
  const id = User.id;
  const response = await axios.post(`${base_url}ppp/${id}/addImage`, formData);

  return response.data;
};
const updatePhotograph = async (News) => {
  const formData = new FormData();
  formData.append("name", News.NewsData.get("name"));
  formData.append("shortName", News.NewsData.get("shortName"));
  formData.append("type", News.NewsData.get("type"));
  formData.append("email", News.NewsData.get("email"));
  formData.append("password", News.NewsData.get("password"));
  formData.append("image", News.NewsData.get("image"));

  const response = await axios.put(
    `${base_url}ppp/editPhotograph/${News.id}`,
    formData,
    config
  );

  return response.data;
};

const getPhotograph = async (id) => {
  const response = await axios.get(`${base_url}ppp/getById/${id}`, config);

  return response.data;
};

const deletePhotograph = async (id) => {
  const UserString = localStorage.getItem("user");
  const User = JSON.parse(UserString);
  const idd = User.id;
  const response = await axios.delete(`${base_url}ppp/${idd}/deleteImage/${id}`, config);

  return response.data;
};
const PhotographService = {
  getPhotographs,
  createPhotographs,
  getPhotograph,
  updatePhotograph,
  deletePhotograph,
};

export default PhotographService;
